import Button from "./Button";
import { Overlay, Label, Message, MessageCard } from "./DataCard";

function MessageModal({ isOpen, onClose, title, children, variant }) {
    if (!isOpen) return null;
    return (
        <Overlay onClick={onClose}>
            <MessageCard onClick={(e) => e.stopPropagation()}>
                {title && (
                    <Label>
                        <h3>{title}</h3>
                    </Label>
                )}
                <Message $variant={variant}>{children}</Message>
                <Button akcija={onClose} sirina="150px" radius="8px" tekst={"U redu"} />
            </MessageCard>
        </Overlay>

    );
}

export default MessageModal;
